import { useContext, useState, useEffect } from "react";
import { ProtectContext } from "../../context/protect_context";
import { setCustomPageTitle } from "../../utils/page_title";
import type { FAQ } from "../../types";

const FAQPage = () => {
  const { data } = useContext(ProtectContext);
  const [openItemIndex, setOpenItemIndex] = useState<number | null>(null);
  const displayItems: FAQ[] = data?.faqs || [];
  const toggleItem = (index: number) => {
    // If clicking the same item, close it. Otherwise, open the new one (closing previous)
    setOpenItemIndex(openItemIndex === index ? null : index);
  };

  // Set page title
  useEffect(() => {
    setCustomPageTitle("Түгээмэл асуулт, хариултууд", data);
  }, [data]);

  return (
    <div className="flex min-h-screen flex-col bg-white">
      {/* Header Section */}
      <section className="bg-white py-12 lg:py-16">
        <div className="mx-auto w-full max-w-5xl px-4 text-center lg:px-8">
          <h1 className="text-4xl font-medium text-gray-800 mb-4 lg:text-5xl">
            Түгээмэл асуулт, хариултууд
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Газар хөдлөлттэй холбоотой ойлголтуудад хариулт өгч байна
          </p>
        </div>
      </section>

      {/* FAQ Accordion Section */}
      <section className="bg-white py-12 lg:py-16">
        <div className="mx-auto w-full max-w-4xl px-4 lg:px-8">
          <div className="space-y-4">
            {displayItems.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500">FAQ мэдээлэл олдсонгүй.</p>
              </div>
            ) : (
              displayItems.map((item: FAQ, index: number) => {
                const isOpen = openItemIndex === index;
                return (
                  <div
                    key={index}
                    className="bg-white rounded-lg  shadow-sm overflow-hidden"
                  >
                    <button
                      onClick={() => toggleItem(index)}
                      className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors group"
                    >
                      <span className="text-lg font-medium text-gray-700 group-hover:text-orange-600 pr-4 transition-colors">
                        {item.title}
                      </span>
                      <svg
                        className={`w-5 h-5 text-red-500 flex-shrink-0 transition-transform ${
                          isOpen ? "rotate-180" : ""
                        }`}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </button>
                    {isOpen && (
                      <div className="px-6 py-4 border-t border-gray-200">
                        <div
                          className="text-gray-700 prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{
                            __html: item.description || "",
                          }}
                        />
                      </div>
                    )}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
